
import { onUnmounted, ref } from 'vue';
import { useToast } from 'primevue/usetoast';
import { copyText } from '../utils/clipboard';

export default {
	name: 'CopyButton',
	props: {
		value: {
			type: [String, Number],
			default: '',
		},
		label: {
			type: String,
			default: '',
		},
		iconClass: {
			type: String,
			default: 'size-5 text-gray-800',
		},
	},
	setup(props) {
		const toast = useToast();

		const copied = ref(false);
		let timer: number | null = null;

		const handleClick = async () => {
			const text = props.value != null ? String(props.value) : '';
			if (!text) return;

			try {
				await copyText(text);

				copied.value = true;
				if (timer !== null) window.clearTimeout(timer);
				timer = window.setTimeout(() => (copied.value = false), 1000);

				toast?.add?.({ severity: 'success', summary: `คัดลอก${props.label}`, detail: 'คัดลอกเรียบร้อย', life: 1500 });
			} catch (error: unknown) {
				const msg = error instanceof Error ? error.message : String(error);
				toast?.add?.({ severity: 'error', summary: 'คัดลอกไม่สำเร็จ', detail: msg, life: 3000 });
			}
		};

		onUnmounted(() => {
			if (timer !== null) window.clearTimeout(timer);
		});

		return {
			copied,
			handleClick,
		};
	},
};
